<template>
    <div class='tab-content'>
        <div class='content'>
            <draggable tag="ul" class="list-group" :list="config" v-bind="dragOptions" :move="checkMove">
                <transition-group type="transition" name="flip-list">
                    <li
                        class="list-group-item"
                        v-for="(element, idx) in config"
                        :key="element.label"
                    >
                        <b-icon-justify class="handle" />

                        <span class="label">{{ element.label }} </span>

                        <div class="com-design-check">
                            <input :id='`check-visible-${element.type}`' type="checkbox" v-model="element.visible" />
                            <label :for='`check-visible-${element.type}`'></label>
                        </div>
                    </li>
                </transition-group>
            </draggable>

            <div class="ticket-container">
                <select-form
                    :select-data="['이용권 구분', ...config.filter(t => t.type).map(t => t.label)]"
                    :select-value="['', ...config.filter(t => t.type).map(t => t.type)]"
                    class="w180"
                    @update:set="(v) => ticketType = v"
                />

                <draggable tag="ul" class="list-group" :list="ticketList" v-bind="dragOptions">
                    <transition-group type="transition" name="flip-list">
                        <li
                            class="list-group-item"
                            v-for="(element, idx) in ticketList"
                            :key="element.cp_center_prod_id"
                        >
                            <b-icon-justify class="handle" />

                            <span class="label">{{ element.cp_namee }} </span>

                            <div class="com-design-check">
                                <input :id='`check-visible-${element.cp_center_prod_id}`' type="checkbox" v-model="element.cp_stoc_use_yn" @change="(e) => onStockUseChange(element)" />
                                <label :for='`check-visible-${element.cp_center_prod_id}`'></label>
                            </div>
                        </li>
                    </transition-group>
                </draggable>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import draggable from "vuedraggable";
import { BIconJustify } from 'bootstrap-vue'
import api from '@/assets/js/api';

const DEFAULT_CONFIG = [
    { label: '전체', type: '', visible: true, fixed: true },
    { label: '개인', type: 'P', visible: true },
    { label: '그룹', type: 'G', visible: true },
    { label: '회원권', type: 'T', visible: true },
    { label: '운동복', type: 'S', visible: true },
    { label: '락커', type: 'L', visible: true },
]

export default {
    name: 'TicketCategory',

    components: {
        draggable,
        BIconJustify
    },

    data() {
        return {
            DEFAULT_CONFIG,
            config: [],

            ticketType: '',
            ticketList: [],
        }
    },

    computed: {
        ...mapState({
            centerId: (state) => state.auth.user.centerId,
        }),

        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },

    mounted() {
        this.getSetting();
    },

    methods: {
        async getSetting() {
            this.isLoading = true;

            try {
                const {data} = await api.get(`/admin/api/center/${this.centerId}/kiosk/config`);

                this.config = Object.values(
                    [...DEFAULT_CONFIG, ...(data.categoryConfig || [])].reduce((acc, cur) => {
                        acc[cur.type] = cur
                        return acc
                    }, {})
                );
            } catch (e) {
                console.error(e);
                alert('로딩에 실패하였습니다.');
            }

            this.isLoading = false;
        },

        async getTickets(type) {
            if (!type) {
                this.ticketList = [];
                return;
            }

            try {
                const {data} = await api.get(`/admin/api/center/${this.centerId}/product/ticket`, {
                    params: {
                        page: 1,
                        limit: 100,
                        sortColumn: 'position',
                        sortType: 'ASC',
                        centerId: this.centerId,
                        ticketType: type,
                        // stockUseYn: true,
                        kioskUsable: true,
                    },
                });

                this.ticketList = data.items;
            } catch (e) {
                console.error(e);
            }
        },

        checkMove(evt) {
            const dragged = evt.draggedContext.element
            const newIndex = evt.relatedContext.index

            // dragged 항목이 fixed면 드래그 금지
            if (dragged.fixed) return false

            // 최상단 위치(0)로 이동 금지
            if (newIndex === 0) return false

            return true
        },

        async onStockUseChange(ticket) {
            try {
                await this.updateProduct(ticket);
            } catch (e) {
                alert('판매여부 업데이트에 실패했습니다.');
            }
        },

        async saveSetting() {
            const params = { categoryConfig: this.config };

            try {
                await api.post(`/admin/api/center/${this.centerId}/kiosk/config`, params);
            } catch (e) {
                alert('저장에 실패했습니다.');
            }
        },

        async updatePosition() {
            const params = { ids: this.ticketList.map(t => t.cp_center_prod_id) };

            try {
                await api.put(`/admin/api/center/${this.centerId}/product/positions`, params);
            } catch (e) {
                alert('표시위치 업데이트에 실패했습니다.');
            }
        },

        async updateProduct(ticket) {
            await api.put(`/admin/api/center/${this.centerId}/product/${ticket.cp_center_prod_id}`,
                {
                    centerId: this.centerId,
                    centerProductVersion: ticket.cp_center_prod_ver,
                    stockUseYn: ticket.cp_stoc_use_yn
                });
        }
    },

    watch: {
        config: {
            handler(newValue, oldValue) {
                this.saveSetting();
            },
            deep: true // Essential for deep watching
        },

        ticketType(v) {
            this.getTickets(v);
        },

        ticketList(newVal, oldVal) {
            if (oldVal.length === 0 || newVal.length === 0) return;

            this.updatePosition();
        },
    }
};
</script>

<style scoped lang='scss'>
.content {
    display: flex;
    flex-direction: row;
}

.list-group {
    width: 240px;
}

.list-group-item:first-child {
    cursor: auto;
}

.list-group-item:first-child svg {
    visibility: hidden;
}

.list-group-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: move;
}

.handle {
    float: left;
}

.label {
    flex: 1;
    font-size: 14px;
    color: #535353;
    padding-left: 8px;
}

.flip-list-move {
    transition: transform 0.5s;
}

.no-move {
    transition: transform 0s;
}

.ghost {
    opacity: 0.5;
    background: #f4f6f7;
}

.ticket-container {
    display: flex;
    flex-direction: column;
    margin-top: 0;
    margin-left: 100px;
}

.ticket-container ul {
    margin-top: 16px;
}

.ticket-container .list-group {
    width: 480px;
}

.ticket-container .list-group-item:first-child {
    cursor: move;
}

.ticket-container .list-group-item:first-child svg {
    visibility: visible;
}
</style>